export default "__VITE_ASSET__C_Xpk34f__"